import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class Blog extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/blog';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetBlogs';

    static model_name = 'Blog';

    static fields() {
        return {
            id: this.attr(null),
            show_count: this.attr(null),
            website_blog_topic_id: this.attr(null),
            country_id: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
        }
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
